import React, { useState } from "react";
import InquiryModal from "../../components/InquiryModal";
import cairoImg from "../../assets/images/cairo.jpg";

const CairoTour: React.FC = () => {
  const [showInquiry, setShowInquiry] = useState(false);

  return (
    <div
      style={{
        padding: "3rem 2rem",
        maxWidth: "900px",
        margin: "0 auto",
        fontFamily: "'Segoe UI', Tahoma, Geneva, Verdana, sans-serif",
        color: "#333",
      }}
    >
      {/* Hero Section */}
      <div
        style={{
          backgroundImage: `url(${cairoImg})`,
          backgroundSize: "cover",
          backgroundPosition: "center",
          borderRadius: "12px",
          padding: "5rem 2rem",
          color: "#fff",
          textAlign: "center",
          marginBottom: "2rem",
          boxShadow: "0 4px 15px rgba(0,0,0,0.2)",
        }}
      >
        <h1 style={{ fontSize: "3rem", fontWeight: 700 }}>Explore Cairo</h1>
        <p style={{ fontSize: "1.25rem", marginTop: "1rem" }}>
          Discover the wonders of ancient Egypt, including the Pyramids and Nile adventures.
        </p>
      </div>

      {/* Highlights */}
      <div style={{ marginBottom: "2rem" }}>
        <h2 style={{ fontSize: "2rem", marginBottom: "1rem" }}>Highlights</h2>
        <ul style={{ paddingLeft: "1.2rem", lineHeight: 1.8 }}>
          <li>Pyramids of Giza & Sphinx</li>
          <li>Nile River cruise</li>
          <li>Egyptian Museum tour</li>
          <li>Local markets and culture</li>
        </ul>
      </div>

      {/* Inquiry Button */}
      <div style={{ textAlign: "center", marginTop: "2rem" }}>
        <button
          onClick={() => setShowInquiry(true)}
          style={{
            padding: "0.8rem 2rem",
            backgroundColor: "#E1306C",
            color: "#fff",
            borderRadius: "6px",
            border: "none",
            fontWeight: "bold",
            cursor: "pointer",
            boxShadow: "0 4px 12px rgba(0,0,0,0.15)",
            transition: "transform 0.3s",
          }}
          onMouseOver={(e) => (e.currentTarget.style.transform = "scale(1.05)")}
          onMouseOut={(e) => (e.currentTarget.style.transform = "scale(1)")}
        >
          Send Inquiry
        </button>
      </div>

      {/* Inquiry Modal */}
      {showInquiry && (
        <InquiryModal
          show={showInquiry}
          onClose={() => setShowInquiry(false)}
          inquiryData={{
            type: "Package", // or "Tour" if you add that type
            name: "",
            email: "",
            phone: "",
            from: undefined,
            to: undefined,
            date: undefined,
          }}
        />
      )}
    </div>
  );
};

export default CairoTour;
